<section class="k-d-grid k-gap-y-md">
    <h5>Encounter ID: {{ submissionDetails?.[0]?.encounterId }}</h5>

    <div class="k-d-grid k-gap-y-xs">
        @for (item of submissionDetails; track $index) {
        <div class="k-d-flex k-gap-x-md">
            <span>{{ item?.createdDate | date: 'MM/dd/yyyy' }}</span>
            <span style="color:var(--tb-kendo-neutral-110)">{{ getActionText(item?.actionStatus?.id) }}
                by {{ item?.createdUser }}</span>
        </div>
        }
    </div>
</section>